// extracted by mini-css-extract-plugin
export default {"slider":"Slider_slider__WU4P-","btn":"Slider_btn__PLpb5","slide":"Slider_slide__XOpDO","swiper":"Slider_swiper__6hD2c"};